module.exports = __webpack_public_path__ + "static/img/bg.3f088c6e.png";